import { useContext } from 'react'
import { useRequiredContext } from '../../../legacy/contexts/utils'
import { AccessControlsContext } from './AccessControlsContext'

export const useAccessControlsContext = () => useRequiredContext(AccessControlsContext)
export const useOptionalAccessControlsContext = () => useContext(AccessControlsContext)
